<template>
  <div class="main-container">
    <div v-if="showIntro">
      <tl-header type="h1">Statutory Info</tl-header>
      <div class="row-container center">
        <div class="company-info">
          <br />
          <img class="image" src="@/assets/statutory.svg" />
          <!-- <div @click="goToStatutoryInfoPage"><img class="closeImage" src="@/assets/close.png" /></div> -->
          <div class="fontStyle">
            <br />
            <br />
            <span>
              It is the information regarding PF, ESIC, PT registration
              and Gratuity detals of your organisation. You can set your
            </span>
            <br />
            <span>preferrences from advance settings in the same section</span>
            <div class="divider"></div>
            <br />
            <br />
            <btn text="Get Started" type="secondary" @click="goToStatutoryInfoPage" />
          </div>
        </div>
      </div>

      <bottom-action-container class="placeAtEnd" v-if="showIntro">
        <btn-skip @navClicked="skip"></btn-skip>
      </bottom-action-container>
    </div>
    <div v-else>
      <statutory @displayIntro="goToIntro" />
    </div>
  </div>
</template>

<script>
import Statutory from "./Statutory.vue";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "StatutoryIntro",
  data() {
    return {
      showIntro: true
    };
  },
  components: {
    Statutory
  },
  activated: function() {
    this.fetchPfData();
    this.fetchFormData();
    this.fetchGratuityData();
    this.fetchit();
    if (
      this.getPfSettingsData[this.le_id] ||
      this.getITSettingsData[this.le_id] ||
      this.getGratuityData[this.le_id] ||
      this.getFormSixteenData[this.le_id]
    ) {
      this.showIntro = false;
    } else {
      this.showIntro = true;
    }
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getPfSettingsData: "onboard/statutoryinfo/pfsettings/getPfData",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData",
      getGratuityData: "onboard/statutoryinfo/gratuity/getGratuityData",
      getFormSixteenData: "onboard/statutoryinfo/formsixteen/getFormData"
    }),

    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      } else {
        return this.getleid(0);
      }
    }
  },
  methods: {
    ...mapActions({
      fetchPf: "onboard/statutoryinfo/pfsettings/fetchAll",
      fetchIT: "onboard/statutoryinfo/incometax/fetchAll",
      fetchGratuity: "onboard/statutoryinfo/gratuity/fetchAll",
      fetchForm: "onboard/statutoryinfo/formsixteen/fetchAll"
    }),
    checkStatutorySettings() {
      if (
        this.getPfSettingsData[this.le_id] ||
        this.getITSettingsData[this.le_id] ||
        this.getGratuityData[this.le_id] ||
        this.getFormSixteenData[this.le_id]
      ) {
        this.showIntro = false;
      } else {
        this.showIntro = true;
      }
    },
    async fetchPfData() {
      try {
        await this.fetchPf(this.le_id);
        if (this.getPfSettingsData[this.le_id]) {
          this.showIntro = false;
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchFormData() {
      try {
        await this.fetchForm(this.le_id);
        if (this.getFormSixteenData[this.le_id]) {
          this.showIntro = false;
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchGratuityData() {
      try {
        await this.fetchGratuity(this.le_id);
        if (this.getGratuityData[this.le_id]) {
          this.showIntro = false;
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchit() {
      try {
        await this.fetchIT(this.le_id);
        if (this.getITSettingsData[this.le_id]) {
          this.showIntro = false;
        }
      } catch (err) {
        //console.log(err);
      }
    },
    navHandler(navType) {
      if (navType == "back") {
        this.$validator.reset();
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/bands`
        });
      }
      if (navType == "next") {
        this.$validator.reset();
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/preferences`
        });
      }
    },
    goToIntro() {
      this.showIntro = true;
    },
    goToStatutoryInfoPage() {
      this.showIntro = false;
    },
    skip() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
      });
    }
  }
};
</script>

<style lang = "scss" scoped>
.row-container {
  .value {
    margin-right: 0;
  }
}

.image {
  margin-top: 30px;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 200px;
}
</style>
